import { z } from 'zod';

export const preprocessFloat = (numberSchema: z.ZodNumber) =>
  z.preprocess((val) => parseFloat(String(val).replace(',', '')), numberSchema);

export const eanSchema = z
  .string()
  .length(18, { message: 'Neplatný formát EANu - musí být 18 čísel' })
  .or(z.string().length(0));

export const emailSchema = z
  .string()
  .email({ message: 'Neplatný formát emailu' })
  .or(z.string().length(0));
